import { GridItem } from "@/shared/components/common/GridItem/GridItem"
import { DashboardCardProps } from "./DashboardCard.model"
import Card from "@/shared/components/common/Card/Card"
import css from './DashboardCard.module.css'

function DashboardCard(props: DashboardCardProps & { rowSpan?: number }) {
  return (
    <GridItem col={props.col} height={props.height} rowSpan={props.rowSpan}>
      <div className={css.cardWrrapper}>
        <Card title={props.title} isHover={props.isHover} onClick={props.onClick}>
          {props.children}
        </Card>
      </div>
    </GridItem>
  )
}

export default DashboardCard